module.exports = __webpack_public_path__ + "static/img/03_pro.398f7b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/03_pro.jpg
// module id = lQCh
// module chunks = 0